const actTemplatesViewActions = {
  ACT_TEMPLATES_VIEW_INIT: 'ACT_TEMPLATES_VIEW_INIT',
  ACT_TEMPLATES_VIEW_SET: 'ACT_TEMPLATES_VIEW_SET'
};
export default actTemplatesViewActions;
